export const checkDownloadMerchDiscounnt = (userProfile) => {
    // console.log(typeof (userProfile.download_merch_code_displayed))
    if(userProfile && userProfile.group_id == 2 && (typeof (userProfile.download_merch_code_displayed) === "undefined")){
        // console.log('ss', userProfile.download_merch_code_displayed)
        if(userProfile.payment_profile_status == 'paid' && (userProfile.profile_status == 'Active' || userProfile.profile_status == 'ACTIVE')){
            return true;
            // console.log('return true paid active');
        } else if(userProfile.payment_profile_status == 'unpaid'){
            // console.log('unpaid');
            return false;
        } else if(userProfile.payment_profile_status == "pending"){
            return false;
            // console.log('pending');
        } else if(userProfile.payment_profile_status == 'canceled' && userProfile.profile_status == 'Cancelled'){
            return false;
        } else if(userProfile.payment_profile_status == 'paused' && userProfile.profile_status == 'Suspend'){
            return false;
        } else {
            // console.log('grroup 2 else');
            return false;
        }
    } else if(userProfile && userProfile.group_id == 3){
        return false;
    }
}